import persons from '@/mixins/persons';
import enums from '@/mixins/enums';
import { getDateFromProperty, isNowInRange } from '@/utils/date';

export default {
  mixins: [persons, enums],
  computed: {
    appConf() {
      return this.$store.state.appConfiguration;
    },
    oneOfPersonHasChangeApplication() {
      return this.insuredPersons
        .some((p) => this.isChangeApplication(p.insuredPersonType));
    },
    courierDisable() { return this.isDeliveryTypeDisable('changeTurnOffCourier', 'establishmentTurnOffCourier'); },
    postDisable() { return this.isDeliveryTypeDisable('changeTurnOffPost', 'establishmentTurnOffPost'); },
    contactPlaceDisable() { return this.isDeliveryTypeDisable('changeTurnOffContactPlace', 'establishmentTurnOffContactPlace'); },
    printDisable() { return this.isDeliveryTypeDisable('changeTurnOffPrint', 'establishmentTurnOffPrint'); },
    eIDDisable() { return this.isDeliveryTypeDisable('changeTurnOffEid', 'establishmentTurnOffEid'); },
    eSignatureDisable() { return this.isDeliveryTypeDisable('changeTurnOffESignature', 'establishmentTurnOffESignature'); },
  },
  methods: {
    /**
     * Returns true if insured type of person is change application.
     * @param insuredPersonType = Object | null
     * @returns boolean
     * */
    isChangeApplication(insuredPersonType) {
      const {
        CHANGE_OF_INSURANCE_COMPANY_ADULT,
        CHANGE_OF_INSURANCE_COMPANY_CHILD,
      } = this.enums.InsuredPersonTypeEnum;
      return insuredPersonType === CHANGE_OF_INSURANCE_COMPANY_ADULT
        || insuredPersonType === CHANGE_OF_INSURANCE_COMPANY_CHILD;
    },
    /**
     * Function returns true if current time is in date time range.
     * @param dateTimeRange = Array<string>
     * @returns boolean
     * */
    isNowInDateTimeRange(dateTimeRange) {
      if (!dateTimeRange || !Array.isArray(dateTimeRange)) return false;
      const from = getDateFromProperty(dateTimeRange[0]);
      const to = getDateFromProperty(dateTimeRange[1]);
      const {
        day, month, year, hours, minutes, seconds,
      } = this.model.now;
      const now = new Date(`${month}/${day}/${year}`);
      now.setHours(hours);
      now.setMinutes(minutes);
      now.setSeconds(seconds);
      return isNowInRange(from, to, now);
    },
    /**
     * Function take path to vuex store properties then returns true
     * if current delivery type should be visible
     * @param changePath = string
     * @param originPath = string
     * @returns boolean
     * */
    isDeliveryTypeDisable(changePath, originPath) {
      const changeApplicationCondition = this.oneOfPersonHasChangeApplication
        && this.isNowInDateTimeRange(this.getParsedProperty(changePath));
      const originApplicationCondition = !this.oneOfPersonHasChangeApplication
        && this.isNowInDateTimeRange(this.getParsedProperty(originPath));
      return changeApplicationCondition || originApplicationCondition;
    },
    /*
    * Function try parsed response from configuration service.
    * If it is able to parse then return parsed value otherwise returns null
    * */
    getParsedProperty(path) {
      let parsedData = null;
      try {
        parsedData = JSON.parse(this.appConf[path]);
      } catch (e) {
        console.log(e);
      }
      return parsedData;
    },
  },
};
